const CONTROL_BUCKET = 'control';
const EXPERIMENT_BUCKET = 'treatment';

export { CONTROL_BUCKET, EXPERIMENT_BUCKET };
